import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Star } from 'lucide-react';
export function HeroSection() {
  return <section className="relative overflow-hidden pt-28 pb-20 lg:pt-32 lg:pb-28" data-id="element-111">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-112">
        <div className="grid grid-cols-1 gap-12 items-center" data-id="element-113">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="text-center max-w-3xl mx-auto" data-id="element-114">
            <div className="px-6 py-4 rounded-3xl bg-gradient-to-r from-orange-500 via-violet-500 to-emerald-500 text-white font-extrabold text-3xl sm:text-4xl lg:text-5xl mb-6 leading-tight shadow-lg" data-id="element-115">
              ¿Tu hijo se niega a probar verduras y cada comida se convierte en
              una batalla?
            </div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.1
          }} className="mb-6 rounded-2xl overflow-hidden shadow-lg border-4 border-emerald-300" data-id="element-116">
              <img src="https://cdn.magicpatterns.com/uploads/rueyTBTWirX8tFBqKabGa7/chicosllorandoheylloyd-image-1771674483003.png" alt="Niños rechazando verduras en la mesa" className="w-full object-cover" data-id="element-117" />
            </motion.div>

            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-tight text-gray-900 mb-6" data-id="element-118">
              ¿Y si tus hijos comieran verduras{' '}
              <span className="text-violet-600" data-id="element-119">sin darse cuenta?</span>
            </h1>

            <p className="text-xl text-gray-700 mb-8 leading-relaxed" data-id="element-120">
              Con el método de camuflaje, vas a ver platos vacíos y escuchar:
              <span className="font-bold italic text-emerald-600" data-id="element-121">
                {' '}
                "¡Quiero más!"{' '}
              </span>
              en solo 15 minutos. Esta es la solución para que coman saludable
              sin llantos ni peleas.
            </p>

            <div className="flex flex-col items-center gap-4 justify-center lg:justify-start" data-id="element-122">
              <div className="w-full flex flex-col items-center justify-center gap-1 px-4 bg-violet-600 rounded-2xl py-4" data-id="element-123">
                <div className="flex items-center gap-2" data-id="element-124">
                  <div className="flex text-yellow-400" data-id="element-125">
                    <Star className="h-5 w-5 fill-current" data-id="element-126" />
                    <Star className="h-5 w-5 fill-current" data-id="element-127" />
                    <Star className="h-5 w-5 fill-current" data-id="element-128" />
                    <Star className="h-5 w-5 fill-current" data-id="element-129" />
                    <Star className="h-5 w-5 fill-current" data-id="element-130" />
                  </div>
                  <span className="text-white font-bold text-sm" data-id="element-131">
                    4.9/5 (opiniones verificadas)
                  </span>
                </div>
                <p className="text-white font-extrabold text-base" data-id="element-132">
                  ✨ Garantía de 60 DÍAS ✨
                </p>
              </div>
              <motion.button onClick={() => {
              const el = document.getElementById('comprar-ahora');
              if (el) el.scrollIntoView({
                behavior: 'smooth'
              });
            }} whileHover={{
              scale: 1.07,
              boxShadow: '0 0 50px rgba(251,191,36,0.85), 0 0 25px rgba(251,146,60,0.7)'
            }} whileTap={{
              scale: 0.96
            }} transition={{
              type: 'spring',
              stiffness: 300,
              damping: 18
            }} className="w-full bg-gradient-to-r from-yellow-400 to-orange-500 text-gray-900 font-extrabold text-xl px-10 py-5 rounded-full shadow-2xl cursor-pointer border-4 border-yellow-200 flex items-center justify-center gap-3" data-id="element-133">
                🛒 Obtener Recetas Ahora
                <ArrowRight className="h-6 w-6" data-id="element-134" />
              </motion.button>
            </div>
          </motion.div>

          {/* Image Content - hidden, kept for decoration only */}
          <motion.div initial={{
          opacity: 0,
          y: 50
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: 'easeOut'
        }} className="hidden" data-id="element-135">
            <div className="absolute inset-0 bg-orange-200 rounded-3xl transform rotate-3 scale-95 blur-xl opacity-50 -z-10" data-id="element-136"></div>
          </motion.div>
        </div>
      </div>

      {/* Background decoration */}
      <div className="absolute top-0 right-0 -mr-20 -mt-20 w-96 h-96 bg-violet-200 rounded-full blur-3xl opacity-50 -z-10" data-id="element-137"></div>
      <div className="absolute bottom-0 left-0 -ml-20 -mb-20 w-80 h-80 bg-emerald-200 rounded-full blur-3xl opacity-60 -z-10" data-id="element-138"></div>
    </section>;
}